import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/iso_azul.svg'
import _imports_1 from '../../assets/corte-de-filtro.png'


const _hoisted_1 = {
  id: "operator",
  class: "general-background"
}
const _hoisted_2 = { class: "text-image-container" }
const _hoisted_3 = { class: "high-text" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-under" }

import AplicationsL from './Aplications-l.vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Operator-l',
  setup(__props) {


    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            class: "img-azul",
            src: _imports_0,
            alt: ""
          }, null, -1)),
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("Operation")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("Operation-1")), 1),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Operation-2")), 1),
            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Operation-3")), 1),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Operation-4")), 1),
            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Operation-5")), 1),
            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Operation-6")), 1)
          ]),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("Reductor-1")), 1),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Reductor-2")), 1),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Reductor-3")), 1),
            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Reductor-4")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("The")), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("Filter")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Under-1")) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Under-2")), 1),
            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Under-3")), 1),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Under-4")), 1),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Under-5")), 1),
            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Under-6")), 1)
          ])
        ])
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "image-background-right" }, [
        _createElementVNode("img", {
          class: "img-a",
          src: _imports_1,
          alt: ""
        })
      ], -1))
    ]),
    _createVNode(AplicationsL)
  ], 64))
}
}

})